<template>
  <v-dialog :model-value="dialog" @update:model-value="$emit('update:dialog', $event)" max-width="500px">
    <v-card>
      <v-card-title>{{ formTitle }}</v-card-title>
      <v-card-text>
        <v-text-field v-model="localEvento.titulo" label="Título" />
        <v-textarea v-model="localEvento.descripcion" label="Descripción" rows="2" auto-grow />
        <v-text-field v-model="localEvento.fecha_inicio" label="Inicio" type="datetime-local" />
        <v-text-field v-model="localEvento.fecha_fin" label="Fin" type="datetime-local" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="cancelar">Cancelar</v-btn>
        <v-btn text color="primary" @click="guardar">Guardar</v-btn>
        <v-btn text color="error" v-if="localEvento.id" @click="eliminar">Eliminar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    editedItem: { type: Object, default: () => ({}) },
    formTitle: String,
  },
  emits: ['update:dialog', 'save', 'delete'],
  data() {
    return {
      localEvento: {
        id: null,
        titulo: '',
        descripcion: '',
        fecha_inicio: '',
        fecha_fin: '',
        ...this.editedItem,
      },
    };
  },
  watch: {
    editedItem: {
      handler(n) {
        this.localEvento = {
          id: null,
          titulo: '',
          descripcion: '',
          fecha_inicio: '',
          fecha_fin: '',
          ...n,
        };
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    cancelar() {
      this.$emit('update:dialog', false);
    },
    guardar() {
      this.$emit('save', { ...this.localEvento });
    },
    eliminar() {
      this.$emit('delete', this.localEvento.id);
    },
  },
};
</script>

